<template>
  <div>
    <v-dialog ref="dialog" v-model="modal2" width="290px">
      <template v-slot:activator="{ on, attrs }">
        <div v-on="on">
          <slot></slot>
        </div>
      </template>
      <v-time-picker
        :max="max"
        :min="min"
        @click:minute="$refs.dialog.save(time)"
        v-if="modal2"
        v-model="time"
        @input="onInput"
        full-width
        color="primary"
      >
        <!-- <v-spacer></v-spacer>
        <v-btn text color="primary" @click="modal2 = false"> Cancel </v-btn>
        <v-btn text color="primary" @click="$refs.dialog.save(time)">
          OK
        </v-btn> -->
      </v-time-picker>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ['value', 'max', 'min'],
  data() {
    return {
      time: this.value,
      modal2: false
    }
  },
  methods: {
    onInput(time) {
      this.menu2 = false
      this.$emit('input', time)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/CustomTimepicker.vue